import { VMEvent } from './config.model'


export default class EventService{

    fetchEvents(): Promise<VMEvent[]> {
        return fetch('api/config/event')
            .then(response => response.json() as Promise<VMEvent[]>);            
    }

    /**
     * Posts an event to the server
     * @param event
     */
    postEvent(event: VMEvent): Promise<any> {
        return fetch('api/config/addevent',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(event)
            })
            .then(response => response.status);
    }

    /**
     * Posts an event to the server
     * @param event
     */
    updateEvent(event: VMEvent): Promise<any> {
        return fetch('api/config/updateevent',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(event)
            })
            .then(response => response.status);
    }


    /**
     * Posts an event to the server
     * @param events
     */
    deleteEvents(events: VMEvent[]): Promise<any> {
        return fetch('api/config/deleteevent',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(events)
            })
            .then(response => response.status);
    }
}